import { Component, DestroyRef, EventEmitter, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

export type UnifiedOrderOutletEvent = {
	type: string;
	payload?: unknown;
};

@Component({
	standalone: false,
	selector: 'bt-company-order-detail',
	templateUrl: './company-order-detail.component.html',
	styleUrls: ['./company-order-detail.component.scss']
})
export class CompanyOrderDetailComponent implements OnInit {
	orderId: string | number | null = null;
	activeSubRoute: string;
	isCreateMode = false;

	readonly #destroyRef = inject(DestroyRef);
	readonly #router = inject(Router);

	tabs = [
		{ id: 'orderInfo', title: 'Order Info', url: 'order-detail-info', disabled: false },
		{ id: 'orderDetails', title: 'Order Details', url: 'order-detail-shots', disabled: false }
	];

	constructor() {
		this.#router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				takeUntilDestroyed(this.#destroyRef)
			)
			.subscribe(() => {
				this.updateRouteInfo();
			});
	}

	ngOnInit(): void {
		this.updateRouteInfo();
	}

	/* logica brutta da sistemare */
	private updateRouteInfo(): void {
		const url = this.#router.url;
		const urlSegments = url.split('/');

		const orderViewIndex = urlSegments.indexOf('order-view');
		if (orderViewIndex !== -1 && urlSegments.length > orderViewIndex + 1) {
			const idSegment = urlSegments[orderViewIndex + 1];
			this.orderId = idSegment === 'new' ? 'new' : !isNaN(Number(idSegment)) ? Number(idSegment) : null;
			this.isCreateMode = this.orderId === 'new';

			if (this.isCreateMode) {
				this.tabs[1].disabled = true; // Disable "Order Details" tab in create mode
			} else {
				this.tabs[1].disabled = false; // Enable "Order Details" tab in view mode
			}

			if (urlSegments.length > orderViewIndex + 2) {
				this.activeSubRoute = urlSegments[orderViewIndex + 2];
			}
		}
	}

	onBack(): void {
		this.#router.navigate(['/company/order-list']);
	}

	selectTab(tabUrl: string): void {
		const id = this.orderId === 'new' ? 'new' : this.orderId;
		this.#router.navigate(['/company/order-view', id, tabUrl]);
	}
}
